<template>
  <div class="widget widget-primary">
    <div class="widget-label">{{ group.label }}</div>
    <div class="widget-value">
      {{ total | currency('£', false) }}
    </div>
    <div class="widget-label">
      (Inc VAT) {{ totalWithVat | currency('£', false) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    group: {
      type: Object,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    }
  },

  computed: {
    total() {
      return this.rateGroupTotal?.agreed_value;
    },

    totalWithVat() {
      if (this.rateGroupTotal) {
        return (
          this.rateGroupTotal.agreed_value +
          this.rateGroupTotal.agreed_value_vat
        );
      }

      return null;
    },

    rateGroupTotal() {
      return this.recovery?.totals?.find(
        total => total.rate_group_id === this.group.id
      );
    }
  }
};
</script>
